module.exports = __webpack_public_path__ + "images/emoji/fax.a7bb531e1254aba4453b.png";